import {useState} from 'react'
import {toast} from 'react-toastify'
import {Button} from 'src/Button'
import {Modal} from '@components/Modal.jsx'
import {ButtonGroup, Input} from 'src/Common'
import {VStack} from '@components/Stack'
import {API} from 'src/util/db'

const LearnSubscribeModal = ({isOpen, type, onRequestClose}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const submitHandler = (e) => {
    const form = e.target
    e.preventDefault()

    const formData = new FormData(form)

    setIsSubmitting(true)
    window
      .fetch(`${API}/form?id=mpzolwky`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      })
      .then(() => {
        setIsSubmitting(false)
        toast.success('You are subscribed!')
        onRequestClose()
      })
  }

  return (
    <Modal isOpen={isOpen} size="small">
      <form
        id="learnForm"
        onSubmit={submitHandler}
        className="new-input-container"
      >
        <VStack gap="1rem" align="stretch">
          <div>
            <Input
              label="Wanna get notified when this course launches? Subscribe with your email below."
              type="email"
              name="email"
              required
            />
            <input type="hidden" name="courseType" defaultValue={type} />
          </div>
          <ButtonGroup noPadding>
            <Button onClick={onRequestClose}>Cancel</Button>

            <Button primary type="submit" isLoading={isSubmitting}>
              Notify me!
            </Button>
          </ButtonGroup>
        </VStack>
      </form>
    </Modal>
  )
}

export {LearnSubscribeModal}
